var e;(function(e){e["PASSWORD"]="password";e["TEXT"]="text";e["NUMBER"]="number";e["HIDDEN"]="hidden"})(e||(e={}));export{e as EInputMode};
//# sourceMappingURL=enums.js.map
